import {Grid, IconButton, makeStyles} from '@material-ui/core';
import FastfoodIcon from '@material-ui/icons/Fastfood';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useEffect } from 'react'
import { useState } from 'react';
import { deepPurple } from '@material-ui/core/colors';
import { IAlreadyBooked, IMenuItem } from '../../../interface/interface';
import { SeatingContainer } from './SeatingContainer';
import { v4 as uuidv4 } from 'uuid';
import { CountDownClock } from '../../../components/ui/CountDownClock';
import { TextArea } from '../../../components/ui/TextArea';
import { canComment } from '../../../constants/constants';
import { v4 } from 'uuid';
import { icon_peopleMinus, icon_peoplePlus } from '../../../assets/images/images';
import { foodCategoryColors } from '../../../constants/foodCategoryColors';
import { dateHasAvailableSeatings } from '../../../utils/dateHasAvailableSeatings';

const useStyles = makeStyles((theme: any) => ({
    menuOptionContainer: {
        background: '#FFFFFF',
        boxShadow: '0px 4px 25px rgba(0, 0, 0, 0.1)',
        marginBottom: 10,
        padding: 15,
        width: '100%',
        display: 'block'
    },
    foodImageContainer: {
        width: '20%',
    },
    optionHeader: {
        margin: 0,
        lineHeight: 1,
        fontSize: 16,
        fontWeight: 700
    },
    description: {
        fontSize: 14,
        fontWeight: 400
    },
    numberOfPeople: {
        margin: 'auto',
        fontSize: 26,
    },
    addPeopleContainer: {
        display: 'flex'
    },
    foodCategory: {
        fontSize: 8,
        color: 'white',
        display: 'flex',
        borderRadius: 50,
        padding: '3px 7px 3px',
        margin: 2,
        backgroundColor: deepPurple[500]
    },
    foodCategoryContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'flex-end'
    },
    allergensContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignContent: 'center',
        cursor: 'pointer'
    },
    allergensDropdown: {
        fontSize: 10,
        lineHeight: 1,
        color: '#999999',
        margin: 0
    },
    timesAndOption:{
        fontSize: 16,
        fontWeight: 700
    },
    seatingsContainer:{
        display:'grid',
        gridTemplateColumns:'47.5% 47.5%',
        width: '100%',
        justifyContent: 'center',
        columnGap: 10,
        rowGap: 10,
        marginTop: 10,
        marginBottom: 10
    },
    seatingsContainerColumn:{
        display:'grid',
        gridTemplateColumns:'100%',
        width: '100%',
        justifyContent: 'center',
        columnGap: 10,
        rowGap: 10,
        marginTop: 10,
        marginBottom: 10
    },
    allergens:{
        fontSize: 10,
        fontWeight: 700,
        color: '#616161',
        paddingBottom: 10
    },
    priceContent:{
        display: "grid",
        justifyContent: "start",
        alignItems: "end",
        gridTemplateColumns: "auto auto",
        fontSize: 16,
        columnGap: 3,
        lineHeight: 1,
        marginBottom: 6
    },
    topRowContainer:{
        marginBottom: 9
    }
}));

interface Props {
    selectedDate: Date;
    countDownTo: Date;
    menuItemOnDate: IMenuItem;
    menuItemsOnDate: IMenuItem[];
    price: number;
    image ?: HTMLImageElement;
    seatingsAsCoulmn?: boolean;
    sortingReverse?: boolean;
    setMenuItemsOnDate: React.Dispatch<React.SetStateAction<any>>;
    eaterGroupBookings: IAlreadyBooked[];
    eaterGroupName: string;
    seatingAvailable?: Map<string,string>;
    seatingCapacities: Map<string,string>;
    canCommentOnBookings: boolean;
}

const MenuItemContainer: React.FC<Props> = ({
    selectedDate, 
    countDownTo, 
    menuItemOnDate, 
    menuItemsOnDate, 
    image, 
    price, 
    seatingsAsCoulmn, 
    sortingReverse, 
    setMenuItemsOnDate, 
    eaterGroupBookings, 
    eaterGroupName,
    seatingAvailable,
    seatingCapacities,
    canCommentOnBookings}) => {

    const classes = useStyles();
    const [showAllergens, setShowAllergens] = useState(false);
    const [countDownView,setCountDownView] = useState<any[]>([])

    let optionCount : number = 0;
    for(let i=0;i<menuItemsOnDate.length;i++){
        if(menuItemsOnDate[i].dish){
            if(menuItemsOnDate[i].dish.content.id=== menuItemOnDate.dish.content.id){
                optionCount = i + 1;
            }
        }
    }

    useEffect(() => {
        var tmpCountDownView : any[] = [];
        setCountDownView([])
        tmpCountDownView.push(
            <div key={v4()}>
                {
                    countDownTo.getTime() > new Date().getTime() ?
                    <CountDownClock price={price} countDownTo={countDownTo} />
                    :
                    <div />
                }
            </div>
        )
        setCountDownView(tmpCountDownView)
    }, [countDownTo]);

    const updateSelectedDishes = (alterCount: number) => {
        const newMenuItems: IMenuItem [] = [];
        menuItemsOnDate.forEach( (selectMenuItemsOnDateItem) => {
            if(selectMenuItemsOnDateItem.dish.content.id === menuItemOnDate.dish.content.id){
                selectMenuItemsOnDateItem.quantity = selectMenuItemsOnDateItem.quantity + alterCount;
            }
            newMenuItems.push(selectMenuItemsOnDateItem)
        });
        setMenuItemsOnDate(newMenuItems);
    }

    const updateComment = (comment: string) => {
        const newMenuItems: IMenuItem [] = [];
        menuItemsOnDate.forEach( (selectMenuItemsOnDateItem) => {
            if(selectMenuItemsOnDateItem.dish.content.id === menuItemOnDate.dish.content.id){
                selectMenuItemsOnDateItem.comment = comment;
            }
            newMenuItems.push(selectMenuItemsOnDateItem)
        });
        setMenuItemsOnDate(newMenuItems);
    }
 
    let viewAllergens = ''
    for (const [index, allergen] of menuItemOnDate.dish.content.allergens.entries()) {
        viewAllergens += allergen
        if(index !== menuItemOnDate.dish.content.allergens.length-1){
            viewAllergens += ', '
        }
    }

    const viewCategories = []
    for (const [index, foodCategory] of menuItemOnDate.dish.content.foodCategories.entries()) {
        const background = {
            backgroundColor: '#999999'
        }

        for(const [index2, value2] of foodCategoryColors.entries()){
            if (value2.category=== foodCategory) {
                background.backgroundColor = value2.color;
            }
        }
        
        viewCategories.push(<div key={foodCategory} className={classes.foodCategory} style={background}>{foodCategory}</div>)
    }

    var seatingsOnMenuItem: any[] = []
    if(seatingAvailable){
        if(dateHasAvailableSeatings(menuItemsOnDate,seatingAvailable)){
            seatingsOnMenuItem = menuItemOnDate.selectableSeatings.map((selectableSeating,index) =>
                <SeatingContainer 
                    key={uuidv4()}
                    isWeekBooking={false}
                    selectableSeating={selectableSeating}
                    menuItemOnDate={menuItemOnDate}
                    menuItemsOnDate={menuItemsOnDate}
                    setMenuItemsOnDate={setMenuItemsOnDate}
                    eaterGroupBookings={eaterGroupBookings.find(eaterGroupBooking => eaterGroupBooking.seatingId === selectableSeating.seating.content.id) ? eaterGroupBookings.find(eaterGroupBooking => eaterGroupBooking.seatingId === selectableSeating.seating.content.id) : undefined }
                    eaterGroupName={eaterGroupName}
                    seatingCapacity={parseInt(seatingCapacities.get(selectableSeating.seating.content.id) as string)}
                />
            );
        } else {
            seatingsOnMenuItem.push(
                <div>Option no longer avaiable</div>
            )
        }
    } else {
        seatingsOnMenuItem = menuItemOnDate.selectableSeatings.map((selectableSeating,index) =>
            <SeatingContainer 
                key={uuidv4()}
                isWeekBooking={false}
                selectableSeating={selectableSeating}
                menuItemOnDate={menuItemOnDate}
                menuItemsOnDate={menuItemsOnDate}
                setMenuItemsOnDate={setMenuItemsOnDate}
                eaterGroupBookings={eaterGroupBookings.find(eaterGroupBooking => eaterGroupBooking.seatingId === selectableSeating.seating.content.id) ? eaterGroupBookings.find(eaterGroupBooking => eaterGroupBooking.seatingId === selectableSeating.seating.content.id) : undefined }
                eaterGroupName={eaterGroupName}
                seatingCapacity={parseInt(seatingCapacities.get(selectableSeating.seating.content.id) as string)}
            />
        );
    }
    

    if(sortingReverse){
        seatingsOnMenuItem.reverse()
    }

    return (
        <Grid container className={classes.menuOptionContainer}>
            {
                seatingAvailable && dateHasAvailableSeatings(menuItemsOnDate,seatingAvailable) ?
                <>
                {image ?  
                    <Grid 
                        item className={classes.foodImageContainer}
                    >
                        <FastfoodIcon />
                    </Grid>
                    : null
                }
                <Grid>
                    <div className={classes.topRowContainer}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <div className={classes.optionHeader}>
                                Option {optionCount} - {menuItemOnDate.dish.content.dishTitle}
                            </div>
                            <Grid
                                className={classes.foodCategoryContainer}>
                                {viewCategories}
                            </Grid>
                        </Grid>
                        <div className={classes.description}>
                            {menuItemOnDate.dish.content.dishDescription}
                        </div>
                    </div>
                    
                    <Grid container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Grid>
                            <div className={classes.priceContent} hidden={price=== 0}>
                                    {price} <div style={{fontSize:10}}>DKK</div>
                            </div>
                            <div >
                            <div>
                                {selectedDate ?
                                <div>
                                    {countDownView}
                                </div>
                                :
                                undefined
                                }
                            </div>
                            <div className={classes.allergensContainer} onClick={() => setShowAllergens(!showAllergens)}>
                                <div  className={classes.allergensDropdown}>
                                    See allergens <ExpandMoreIcon style={{fontSize:"1rem"}}/>
                                </div>
                            </div>
                            </div>
                        </Grid>
                        <Grid
                            className={classes.addPeopleContainer}
                        >
                            <IconButton  aria-label="add an alarm" onClick={() => updateSelectedDishes(-1)} disabled={menuItemOnDate.quantity=== 0}>
                                <img src={icon_peopleMinus}/>
                            </IconButton>
                            <div className={classes.numberOfPeople}>
                                {menuItemOnDate.quantity}
                            </div>
                            <IconButton color="secondary" aria-label="add an alarm" onClick={() => updateSelectedDishes(+1)}>
                                <img src={icon_peoplePlus}/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
                {showAllergens ? 
                    <div className={classes.allergens}>
                        {viewAllergens}
                    </div>
                    : null
                }
                {
                    menuItemOnDate.quantity > 0 ?
                    <div>
                        <div className={classes.timesAndOption}>Choose an option</div>
                        <div>
                            {seatingsAsCoulmn ? 
                            <div className={classes.seatingsContainerColumn}>
                                {seatingsOnMenuItem}
                            </div>
                            :
                            <div className={classes.seatingsContainer}>
                                {seatingsOnMenuItem}
                            </div>
                            }
                        </div> 
                        {
                            canCommentOnBookings &&
                            <div>
                            <div className={classes.timesAndOption}>Comments</div>
                                <TextArea placeholder='Comments, notes etc' rows={2} defaultValue={menuItemOnDate.comment} onBlur={(e) => {updateComment(e.target.value)}} />
                            </div>
                        }    
                    </div>
                    :
                    <div></div>
                }
                </>
                :
                <div>Option no longer avaiable</div>
            }
        </Grid>
    );
}

export default MenuItemContainer;